import React from 'react';

import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

import { useTranslation } from 'lib/i18n';

import { mediaSelector } from 'helpers/style-utils';

import { headingId } from './TosNavigation';
import { PageNames } from './TosPage';

const StyledTosText = styled.nav`
  width: 700px;

  h2 {
    ${p => p.theme.fonts.titleBold}
    font-size: 4.8rem;
    line-height: 4.32rem;
    letter-spacing: -0.04em;

    // Padding with negative margin makes it look nicer when you jump to header via anchor.
    position: relative;
    margin: -2.2rem 0 3rem 0;
    padding: 3rem 0 0 0;
  }

  p, li {
    ${p => p.theme.fonts.titleBold}
    font-size: 2.2rem;
    line-height: 3.3rem;
    margin: 0 0 3.3rem 0;
    ${mediaSelector.mobile} {
      margin: 0 3% 3.3rem 3%;
    }
  }

  ol, ul {
    margin: 0; padding: 0;
  }
  li {
    padding 0;
  }
`;

type Props = {
  pageName: PageNames;
};

const Heading: React.FC<{ level: number; children: JSX.Element[] }> = ({ level, children }) => {
  if (level >= 2) {
    return <h2 id={headingId(children)}>{children}</h2>;
  }
  return null;
};

const TosText: React.FC<Props> = ({ pageName }) => {
  const { t } = useTranslation('tos');
  return (
    <StyledTosText>
      <ReactMarkdown
        source={t(`${pageName}.text`)}
        renderers={{
          heading: Heading,
        }}
      />
    </StyledTosText>
  );
};

export default TosText;
